<template>
  <v-card dark :loading="loading">
    <v-card-title class="d-flex justify-center">
      <h3 class="text-h6">Associação Produtos Tray x Gestão</h3>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="selectedTab" dark>
        <v-tabs-slider color="red"></v-tabs-slider>
        <v-tab>
          Geral
        </v-tab>
        <v-tab>
          Resultado
        </v-tab>

        <v-tab-item>
          <v-card flat dark>
            <v-card-title class="d-flex justify-center text-subtitle-1"
              >Configurações de Leitura</v-card-title
            >
            <v-container>
              <div class="d-flex flex-row">
                <v-text-field
                  v-model="startLine"
                  type="number"
                  class="text-caption"
                  label="Linha Cabeçalho dos Produtos"
                  placeholder="Exemplo: 9"
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  v-model="deadline"
                  type="number"
                  label="Linha Cabeçalho das Variações"
                  class="text-caption ml-4"
                  placeholder="Exemplo: 20"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <v-file-input
                v-model="file"
                label="Localizar arquivo para importação .xlsx"
                dense
                outlined
                @change="changeFile"
              ></v-file-input>

              <v-divider></v-divider>
              <v-card-subtitle class="d-flex justify-center text-subtitle-1"
                >Seleção de colunas para associação</v-card-subtitle
              >
              <div class="d-flex flex-row">
                <v-select
                  v-model="fieldTray"
                  :items="trayColumns"
                  item-text="text"
                  item-value="value"
                  class="text-caption"
                  label="Coluna Código Tray"
                  placeholder="Exemplo: ID"
                  persistent-placeholder
                  dense
                  dark
                  clearable
                  outlined
                  return-object
                />

                <v-select
                  v-model="fieldMegabit"
                  :items="trayColumns"
                  item-text="text"
                  item-value="value"
                  class="text-caption ml-4"
                  label="Coluna Código Gestão"
                  placeholder="Exemplo: REFERENCIA"
                  persistent-placeholder
                  dense
                  dark
                  clearable
                  outlined
                  return-object
                />
              </div>
              <v-checkbox v-model="isAtivo" label="Marcar itens como ATIVO">
              </v-checkbox>
            </v-container>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat dark>
            <v-data-table
              dark
              :items="listProducts"
              :headers="headers"
              :items-per-page="5"
            />
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card-text>

    <v-card-actions>
      <v-btn color="red darken-4" @click.prevent="$emit('close')">
        <span class="text-overline">Sair</span>
      </v-btn>
      <v-spacer />
      <v-btn color="warning" @click.prevent="clearData('form')">
        <span class="text-overline">Reiniciar</span>
        <v-icon right>mdi-reload</v-icon>
      </v-btn>
      <v-btn color="info" @click.prevent="getColumnValues()">
        <span class="text-overline">Importar</span>
        <v-icon right>mdi-file-import</v-icon>
      </v-btn>
      <v-btn
        color="success"
        @click.prevent="$emit('associateProducts', listProducts)"
      >
        <span class="text-overline">Associar</span>
        <v-icon right>mdi-database</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import XLSX from 'xlsx'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ProductsAssociation',
  computed: {
    ...mapGetters({ columnsAvaiable: 'trayModule/getProductColumnsAvaiable' }),
    columnsLabeled() {
      return [
        {
          text: 'Código',
          value: 'CODIGO',
        },
      ]
    },
  },
  data() {
    return {
      integrationType: 'Produtos',
      integrationTypeList: ['Produtos'],
      loading: false,
      isAtivo: false,
      selectedTab: 0,
      startLine: 9,
      deadline: null,
      startColumn: null,
      fieldTray: null,
      fieldMegabit: null,
      file: null,
      worksheet: {},
      worksheetJson: {},
      trayColumns: [],
      listProducts: [],
      headers: [
        { text: 'Código Tray', value: 'IDITEMINTEGRACAO', width: 250 },
        { text: 'Código Gestão', value: 'CODIGO', width: 250 },
      ],
    }
  },
  props: {
    integrationColumns: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    ...mapActions({
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),

    async getColumnValues() {
      try {
        this.loading = true

        if (!this.startLine) throw 'Linha Cabeçalho Produtos não foi informada'
        else if (!this.deadline)
          throw 'Linha Cabeçalho Variação de Produtos não foi informada (linha final para leitura)'
        else if (!this.file) throw 'Arquivo não foi selecionado'
        else if (!this.fieldTray) throw 'Coluna Código Tray não selecionada'
        else if (!this.fieldMegabit)
          throw 'Coluna Código Gestão não selecionada'

        this.listProducts = []
        Object.keys(this.worksheet).forEach((row) => {
          const line = row.replace(/[^0-9]+/g, '')

          if (
            parseInt(line) > this.startLine &&
            parseInt(line) < this.deadline - 2
          ) {
            const keyTray = this.fieldTray.value + line.toString()
            const keyGestao = this.fieldMegabit.value + line.toString()

            if (this.worksheet[keyTray]?.v && this.worksheet[keyGestao]?.v) {
              const idTray = this.worksheet[keyTray].v
              const idGestao = this.worksheet[keyGestao].v

              if (
                this.listProducts.filter((item) => item.CODIGO == idGestao)
                  .length <= 0
              ) {
                this.listProducts.push({
                  CODIGO: idGestao,
                  IDITEMINTEGRACAO: idTray,
                  VENDAINTERNET: this.isAtivo ? 'S' : 'N',
                })
              }
            }
          }
        })
        this.$toasted.success('Importação concluída com sucesso')
        this.selectedTab = 1
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.loading = !this.loading
      }
    },
    setWorksheet(workbook) {
      const first_sheet_name = workbook.SheetNames[0]
      this.worksheet = workbook.Sheets[first_sheet_name]
      this.worksheetJson = XLSX.utils.sheet_to_json(this.worksheet)
    },
    clearData(type = 'form') {
      this.worksheet = null
      this.worksheetJson = null
      this.trayColumns = []
      if (type == 'form') {
        this.startLine = null
        this.deadline = null
        this.file = null
        this.fieldTray = null
        this.fieldMegabit = null
        this.listProducts = []
        this.selectedTab = 0
      }
    },
    async changeFile($event) {
      this.clearData('file')
      if ($event) {
        try {
          this.loading = true
          const file = $event
          const fileExtension = file.name.split('.')[1]
          if (fileExtension == 'xls') {
            const data = await file.arrayBuffer()
            const workbook = XLSX.read(data)
            await this.setWorksheet(workbook)
            await this.manageFile()
            await this.setDefaultValues()
          } else {
            this.$toasted.info(`Arquivo [*.${fileExtension}] não suportado.`)
          }
        } finally {
          this.loading = !this.loading
        }
      }
    },

    setDefaultValues() {
      this.fieldTray = this.trayColumns.filter((v) => v.text == 'ID')[0]
      this.fieldMegabit = this.trayColumns.filter(
        (v) => v.text == 'REFERENCIA'
      )[0]
    },

    async manageFile() {
      Object.keys(this.worksheet).forEach((key) => {
        const line = key.replace(/[^0-9]+/g, '')
        const column = key.replace(/[^a-zA-Z.]/g, '')
        const value = this.worksheet[key].v

        if (line == this.startLine) {
          this.trayColumns.push({
            text: value,
            value: column,
          })
        }
      })
    },
  },
  mounted() {
    if (this.integrationColumns.length > 0)
      this.trayColumns = [...this.integrationColumns]
  },
}
</script>

<style scoped>
.boxConfig {
  border: 1px solid #eceff1;
}
</style>
